import React from "react";

import { CardRow, StructureSection } from "../OpenBoxQuotes/BoxStructureFields";
import { AccessoryNoteCard } from "./AccessoriesCards";
import { insulatedKey } from "./BoxStructureCards";

const AccessoriesLocks = () => (
  <StructureSection titleKey={insulatedKey("SECTIONS.LOCKS")}>
    <CardRow columns={3}>
      <AccessoryNoteCard
        cardKey="hydraulicControlBoxLock"
        titleKey={insulatedKey("CARDS.HYDRAULIC_CONTROL_BOX_LOCK")}
      />
      <AccessoryNoteCard
        cardKey="ureaLock"
        titleKey={insulatedKey("CARDS.UREA_LOCK")}
      />
      <AccessoryNoteCard
        cardKey="dieselLock"
        titleKey={insulatedKey("CARDS.DIESEL_LOCK")}
      />
    </CardRow>
    <CardRow columns={3}>
      <AccessoryNoteCard
        cardKey="sideDoorLock"
        titleKey={insulatedKey("CARDS.SIDE_DOOR_LOCK")}
      />
      <AccessoryNoteCard
        cardKey="hydraulicSideLockEar"
        titleKey={insulatedKey("CARDS.HYDRAULIC_SIDE_LOCK_EAR")}
      />
      <AccessoryNoteCard
        cardKey="batteriesLock"
        titleKey={insulatedKey("CARDS.BATTERIES_LOCK")}
      />
    </CardRow>
  </StructureSection>
);

export default AccessoriesLocks;
